import L, { useRef as D, useCallback as R, useState as W, useContext as G, useEffect as _, useMemo as ie, forwardRef as ke, createContext as Q } from "react";
import Ln, { flushSync as _t } from "react-dom";
function Vt(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Vt(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Cn() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Vt(e)) && (r && (r += " "), r += t);
  return r;
}
const Z = typeof document < "u" ? L.useLayoutEffect : () => {
};
function re(e) {
  const t = D(null);
  return Z(() => {
    t.current = e;
  }, [
    e
  ]), R((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const Oe = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, zt = /* @__PURE__ */ L.createContext(Oe), On = /* @__PURE__ */ L.createContext(!1);
let Fn = !!(typeof window < "u" && window.document && window.document.createElement), Be = /* @__PURE__ */ new WeakMap();
function Mn(e = !1) {
  let t = G(zt), n = D(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = L.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let l = Be.get(i);
      l == null ? Be.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== l.state && (t.current = l.id, Be.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function In(e) {
  let t = G(zt);
  t === Oe && !Fn && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Mn(!!e), r = t === Oe && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Dn(e) {
  let t = L.useId(), [n] = W(lt()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Oe.prefix}`;
  return e || `${r}-${t}`;
}
const Hn = typeof L.useId == "function" ? Dn : In;
function kn() {
  return !1;
}
function Nn() {
  return !0;
}
function Rn(e) {
  return () => {
  };
}
function lt() {
  return typeof L.useSyncExternalStore == "function" ? L.useSyncExternalStore(Rn, kn, Nn) : G(On);
}
let An = !!(typeof window < "u" && window.document && window.document.createElement), de = /* @__PURE__ */ new Map(), me;
typeof FinalizationRegistry < "u" && (me = new FinalizationRegistry((e) => {
  de.delete(e);
}));
function pe(e) {
  let [t, n] = W(e), r = D(null), o = Hn(t), i = D(null);
  if (me && me.register(i, o), An) {
    const l = de.get(o);
    l && !l.includes(r) ? l.push(r) : de.set(o, [
      r
    ]);
  }
  return Z(() => {
    let l = o;
    return () => {
      me && me.unregister(i), de.delete(l);
    };
  }, [
    o
  ]), _(() => {
    let l = r.current;
    return l && n(l), () => {
      l && (r.current = null);
    };
  }), o;
}
function Kn(e, t) {
  if (e === t) return e;
  let n = de.get(e);
  if (n)
    return n.forEach((o) => o.current = t), t;
  let r = de.get(t);
  return r ? (r.forEach((o) => o.current = e), e) : t;
}
function at(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const V = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, X = (e) => e && "window" in e && e.window === e ? e : V(e).defaultView || window;
function _n(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function Vn(e) {
  return _n(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let zn = !1;
function st() {
  return zn;
}
function H(e, t) {
  if (!st()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : Vn(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Ee = (e = document) => {
  var t;
  if (!st()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function M(e) {
  return st() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function j(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let i = t[o], l = r[o];
      typeof i == "function" && typeof l == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = at(i, l) : (o === "className" || o === "UNSAFE_className") && typeof i == "string" && typeof l == "string" ? t[o] = Cn(i, l) : o === "id" && i && l ? t.id = Kn(i, l) : t[o] = l !== void 0 ? l : i;
    }
  }
  return t;
}
function Bn(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = gt(o, t);
      return n || (n = typeof i == "function"), i;
    });
    if (n) return () => {
      r.forEach((o, i) => {
        typeof o == "function" ? o() : gt(e[i], null);
      });
    };
  };
}
function gt(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
const Un = /* @__PURE__ */ new Set([
  "id"
]), Wn = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), jn = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Gn = /^(data-.*)$/;
function Ne(e, t = {}) {
  let { labelable: n, isLink: r, propNames: o } = t, i = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (Un.has(l) || n && Wn.has(l) || r && jn.has(l) || o != null && o.has(l) || Gn.test(l)) && (i[l] = e[l]);
  return i;
}
function ve(e) {
  if (Yn()) e.focus({
    preventScroll: !0
  });
  else {
    let t = Xn(e);
    e.focus(), Zn(t);
  }
}
let we = null;
function Yn() {
  if (we == null) {
    we = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return we = !0, !0;
        }
      });
    } catch {
    }
  }
  return we;
}
function Xn(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Zn(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function Re(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function ct(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function te(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const be = te(function() {
  return ct(/^Mac/i);
}), qn = te(function() {
  return ct(/^iPhone/i);
}), Bt = te(function() {
  return ct(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  be() && navigator.maxTouchPoints > 1;
}), ut = te(function() {
  return qn() || Bt();
});
te(function() {
  return be() || ut();
});
const Ut = te(function() {
  return Re(/AppleWebKit/i) && !Jn();
}), Jn = te(function() {
  return Re(/Chrome/i);
}), Wt = te(function() {
  return Re(/Android/i);
}), Qn = te(function() {
  return Re(/Firefox/i);
});
function Pe(e, t, n = !0) {
  var r, o;
  let { metaKey: i, ctrlKey: l, altKey: a, shiftKey: u } = t;
  Qn() && (!((o = window.event) === null || o === void 0 || (r = o.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (be() ? i = !0 : l = !0);
  let d = Ut() && be() && !Bt() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: l,
    altKey: a,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: l,
    altKey: a,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  Pe.isOpening = n, ve(e), e.dispatchEvent(d), Pe.isOpening = !1;
}
Pe.isOpening = !1;
let oe = /* @__PURE__ */ new Map(), Xe = /* @__PURE__ */ new Set();
function mt() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let o = oe.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), oe.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let o = oe.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), oe.delete(r.target)), oe.size === 0)) {
      for (let i of Xe) i();
      Xe.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? mt() : document.addEventListener("DOMContentLoaded", mt));
function er() {
  for (const [e] of oe)
    "isConnected" in e && !e.isConnected && oe.delete(e);
}
function jt(e) {
  requestAnimationFrame(() => {
    er(), oe.size === 0 ? e() : Xe.add(e);
  });
}
function dt() {
  let e = D(/* @__PURE__ */ new Map()), t = R((o, i, l, a) => {
    let u = a != null && a.once ? (...d) => {
      e.current.delete(l), l(...d);
    } : l;
    e.current.set(l, {
      type: i,
      eventTarget: o,
      fn: u,
      options: a
    }), o.addEventListener(i, u, a);
  }, []), n = R((o, i, l, a) => {
    var u;
    let d = ((u = e.current.get(l)) === null || u === void 0 ? void 0 : u.fn) || l;
    o.removeEventListener(i, d, a), e.current.delete(l);
  }, []), r = R(() => {
    e.current.forEach((o, i) => {
      n(o.eventTarget, o.type, i, o.options);
    });
  }, [
    n
  ]);
  return _(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function tr(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = pe(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      n,
      ...o.trim().split(/\s+/)
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
function Gt(e) {
  const t = D(null), n = D(void 0), r = R((o) => {
    if (typeof e == "function") {
      const i = e, l = i(o);
      return () => {
        typeof l == "function" ? l() : i(null);
      };
    } else if (e)
      return e.current = o, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return ie(() => ({
    get current() {
      return t.current;
    },
    set current(o) {
      t.current = o, n.current && (n.current(), n.current = void 0), o != null && (n.current = r(o));
    }
  }), [
    r
  ]);
}
function nr() {
  return typeof window.ResizeObserver < "u";
}
function ht(e) {
  const { ref: t, box: n, onResize: r } = e;
  _(() => {
    let o = t == null ? void 0 : t.current;
    if (o)
      if (nr()) {
        const i = new window.ResizeObserver((l) => {
          l.length && r();
        });
        return i.observe(o, {
          box: n
        }), () => {
          o && i.unobserve(o);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t,
    n
  ]);
}
function Yt(e, t) {
  Z(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Ze(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Wt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function rr(e) {
  return !Wt() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function or(e, t = !0) {
  let [n, r] = W(!0), o = n && t;
  return Z(() => {
    if (o && e.current && "getAnimations" in e.current)
      for (let i of e.current.getAnimations()) i instanceof CSSTransition && i.cancel();
  }, [
    e,
    o
  ]), Xt(e, o, R(() => r(!1), [])), o;
}
function ir(e, t) {
  let [n, r] = W(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let o = n === "exiting";
  return Xt(e, o, R(() => {
    r((i) => i === "exiting" ? "closed" : i);
  }, [])), o;
}
function Xt(e, t, n) {
  Z(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let o = !1;
      return Promise.all(r.map((i) => i.finished)).then(() => {
        o || _t(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        o = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Zt = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], lr = Zt.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Zt.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function ar(e) {
  return e.matches(lr);
}
function qt(e, t, n) {
  let [r, o] = W(e || t), i = D(e !== void 0), l = e !== void 0;
  _(() => {
    let d = i.current;
    d !== l && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${d ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}.`), i.current = l;
  }, [
    l
  ]);
  let a = l ? e : r, u = R((d, ...f) => {
    let p = (g, ...b) => {
      n && (Object.is(a, g) || n(g, ...b)), l || (a = g);
    };
    typeof d == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((b, ...m) => {
      let $ = d(l ? a : b, ...m);
      return p($, ...f), l ? b : $;
    })) : (l || o(d), p(d, ...f));
  }, [
    l,
    a,
    n
  ]);
  return [
    a,
    u
  ];
}
function Te(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const sr = Symbol("default");
function cr({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ L.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Ae(e) {
  let { className: t, style: n, children: r, defaultClassName: o, defaultChildren: i, defaultStyle: l, values: a } = e;
  return ie(() => {
    let u, d, f;
    return typeof t == "function" ? u = t({
      ...a,
      defaultClassName: o
    }) : u = t, typeof n == "function" ? d = n({
      ...a,
      defaultStyle: l || {}
    }) : d = n, typeof r == "function" ? f = r({
      ...a,
      defaultChildren: i
    }) : r == null ? f = i : f = r, {
      className: u ?? o,
      style: d || l ? {
        ...l,
        ...d
      } : void 0,
      children: f ?? i,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    o,
    i,
    l,
    a
  ]);
}
function ur(e, t) {
  let n = G(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || sr;
    if (!n.slots[r]) {
      let o = new Intl.ListFormat().format(Object.keys(n.slots).map((l) => `"${l}"`)), i = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${i} Valid slot names are ${o}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Ke(e, t, n) {
  let r = ur(n, e.slot) || {}, { ref: o, ...i } = r, l = Gt(ie(() => Bn(t, o), [
    t,
    o
  ])), a = j(i, e);
  return "style" in i && i.style && "style" in e && e.style && (typeof i.style == "function" || typeof e.style == "function" ? a.style = (u) => {
    let d = typeof i.style == "function" ? i.style(u) : i.style, f = {
      ...u.defaultStyle,
      ...d
    }, p = typeof e.style == "function" ? e.style({
      ...u,
      defaultStyle: f
    }) : e.style;
    return {
      ...f,
      ...p
    };
  } : a.style = {
    ...i.style,
    ...e.style
  }), [
    a,
    l
  ];
}
function dr(e = !0) {
  let [t, n] = W(e), r = D(!1), o = R((i) => {
    r.current = !0, n(!!i);
  }, []);
  return Z(() => {
    r.current || n(!1);
  }, []), [
    o,
    t
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const fr = /* @__PURE__ */ Q(!1);
function pr(e) {
  let t = (n, r) => G(fr) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, ke(t);
}
function ft(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function Jt(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function Qt(e) {
  let t = D({
    isFocused: !1,
    observer: null
  });
  Z(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = re((r) => {
    e == null || e(r);
  });
  return R((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, i = (l) => {
        if (t.current.isFocused = !1, o.disabled) {
          let a = ft(l);
          n(a);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var l;
          (l = t.current.observer) === null || l === void 0 || l.disconnect();
          let a = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Fe = !1;
function yt(e) {
  for (; e && !ar(e); ) e = e.parentElement;
  let t = X(e), n = t.document.activeElement;
  if (!n || n === e) return;
  Fe = !0;
  let r = !1, o = (f) => {
    (f.target === n || r) && f.stopImmediatePropagation();
  }, i = (f) => {
    (f.target === n || r) && (f.stopImmediatePropagation(), !e && !r && (r = !0, ve(n), u()));
  }, l = (f) => {
    (f.target === e || r) && f.stopImmediatePropagation();
  }, a = (f) => {
    (f.target === e || r) && (f.stopImmediatePropagation(), r || (r = !0, ve(n), u()));
  };
  t.addEventListener("blur", o, !0), t.addEventListener("focusout", i, !0), t.addEventListener("focusin", a, !0), t.addEventListener("focus", l, !0);
  let u = () => {
    cancelAnimationFrame(d), t.removeEventListener("blur", o, !0), t.removeEventListener("focusout", i, !0), t.removeEventListener("focusin", a, !0), t.removeEventListener("focus", l, !0), Fe = !1, r = !1;
  }, d = requestAnimationFrame(u);
  return u;
}
let ue = "default", qe = "", Ce = /* @__PURE__ */ new WeakMap();
function Et(e) {
  if (ut()) {
    if (ue === "default") {
      const t = V(e);
      qe = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    ue = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ce.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Ue(e) {
  if (ut()) {
    if (ue !== "disabled") return;
    ue = "restoring", setTimeout(() => {
      jt(() => {
        if (ue === "restoring") {
          const t = V(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = qe || ""), qe = "", ue = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ce.has(e)) {
    let t = Ce.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ce.delete(e);
  }
}
const en = L.createContext({
  register: () => {
  }
});
en.displayName = "PressResponderContext";
function vr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function tn(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function br(e, t) {
  var n = tn(e, t, "get");
  return vr(e, n);
}
function $r(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function gr(e, t, n) {
  $r(e, t), t.set(e, n);
}
function mr(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function Pt(e, t, n) {
  var r = tn(e, t, "set");
  return mr(e, r, n), n;
}
function hr(e) {
  let t = G(en);
  if (t) {
    let { register: n, ...r } = t;
    e = j(r, e), n();
  }
  return Yt(t, e.ref), e;
}
var xe = /* @__PURE__ */ new WeakMap();
class Se {
  continuePropagation() {
    Pt(this, xe, !1);
  }
  get shouldStopPropagation() {
    return br(this, xe);
  }
  constructor(t, n, r, o) {
    gr(this, xe, {
      writable: !0,
      value: void 0
    }), Pt(this, xe, !0);
    var i;
    let l = (i = o == null ? void 0 : o.target) !== null && i !== void 0 ? i : r.currentTarget;
    const a = l == null ? void 0 : l.getBoundingClientRect();
    let u, d = 0, f, p = null;
    r.clientX != null && r.clientY != null && (f = r.clientX, p = r.clientY), a && (f != null && p != null ? (u = f - a.left, d = p - a.top) : (u = a.width / 2, d = a.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = d;
  }
}
const Tt = Symbol("linkClicked"), wt = "react-aria-pressable-style", xt = "data-react-aria-pressable";
function yr(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: o, onPressUp: i, onClick: l, isDisabled: a, isPressed: u, preventFocusOnPress: d, shouldCancelOnPointerExit: f, allowTextSelectionOnPress: p, ref: g, ...b } = hr(e), [m, $] = W(!1), h = D({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: E, removeAllGlobalListeners: P } = dt(), S = re((s, y) => {
    let O = h.current;
    if (a || O.didFirePressStart) return !1;
    let v = !0;
    if (O.isTriggeringEvent = !0, r) {
      let C = new Se("pressstart", y, s);
      r(C), v = C.shouldStopPropagation;
    }
    return n && n(!0), O.isTriggeringEvent = !1, O.didFirePressStart = !0, $(!0), v;
  }), F = re((s, y, O = !0) => {
    let v = h.current;
    if (!v.didFirePressStart) return !1;
    v.didFirePressStart = !1, v.isTriggeringEvent = !0;
    let C = !0;
    if (o) {
      let c = new Se("pressend", y, s);
      o(c), C = c.shouldStopPropagation;
    }
    if (n && n(!1), $(!1), t && O && !a) {
      let c = new Se("press", y, s);
      t(c), C && (C = c.shouldStopPropagation);
    }
    return v.isTriggeringEvent = !1, C;
  }), I = re((s, y) => {
    let O = h.current;
    if (a) return !1;
    if (i) {
      O.isTriggeringEvent = !0;
      let v = new Se("pressup", y, s);
      return i(v), O.isTriggeringEvent = !1, v.shouldStopPropagation;
    }
    return !0;
  }), x = re((s) => {
    let y = h.current;
    if (y.isPressed && y.target) {
      y.didFirePressStart && y.pointerType != null && F(ce(y.target, s), y.pointerType, !1), y.isPressed = !1, y.isOverTarget = !1, y.activePointerId = null, y.pointerType = null, P(), p || Ue(y.target);
      for (let O of y.disposables) O();
      y.disposables = [];
    }
  }), z = re((s) => {
    f && x(s);
  }), U = re((s) => {
    l == null || l(s);
  }), B = re((s, y) => {
    if (l) {
      let O = new MouseEvent("click", s);
      Jt(O, y), l(ft(O));
    }
  }), k = ie(() => {
    let s = h.current, y = {
      onKeyDown(v) {
        if (We(v.nativeEvent, v.currentTarget) && H(v.currentTarget, M(v.nativeEvent))) {
          var C;
          Ct(M(v.nativeEvent), v.key) && v.preventDefault();
          let c = !0;
          if (!s.isPressed && !v.repeat) {
            s.target = v.currentTarget, s.isPressed = !0, s.pointerType = "keyboard", c = S(v, "keyboard");
            let T = v.currentTarget, w = (K) => {
              We(K, T) && !K.repeat && H(T, M(K)) && s.target && I(ce(s.target, K), "keyboard");
            };
            E(V(v.currentTarget), "keyup", at(w, O), !0);
          }
          c && v.stopPropagation(), v.metaKey && be() && ((C = s.metaKeyEvents) === null || C === void 0 || C.set(v.key, v.nativeEvent));
        } else v.key === "Meta" && (s.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(v) {
        if (!(v && !H(v.currentTarget, M(v.nativeEvent))) && v && v.button === 0 && !s.isTriggeringEvent && !Pe.isOpening) {
          let C = !0;
          if (a && v.preventDefault(), !s.ignoreEmulatedMouseEvents && !s.isPressed && (s.pointerType === "virtual" || Ze(v.nativeEvent))) {
            let c = S(v, "virtual"), T = I(v, "virtual"), w = F(v, "virtual");
            U(v), C = c && T && w;
          } else if (s.isPressed && s.pointerType !== "keyboard") {
            let c = s.pointerType || v.nativeEvent.pointerType || "virtual";
            C = F(ce(v.currentTarget, v), c, !0), s.isOverTarget = !1, U(v), x(v);
          }
          s.ignoreEmulatedMouseEvents = !1, C && v.stopPropagation();
        }
      }
    }, O = (v) => {
      var C;
      if (s.isPressed && s.target && We(v, s.target)) {
        var c;
        Ct(M(v), v.key) && v.preventDefault();
        let w = M(v), K = H(s.target, M(v));
        F(ce(s.target, v), "keyboard", K), K && B(v, s.target), P(), v.key !== "Enter" && pt(s.target) && H(s.target, w) && !v[Tt] && (v[Tt] = !0, Pe(s.target, v, !1)), s.isPressed = !1, (c = s.metaKeyEvents) === null || c === void 0 || c.delete(v.key);
      } else if (v.key === "Meta" && (!((C = s.metaKeyEvents) === null || C === void 0) && C.size)) {
        var T;
        let w = s.metaKeyEvents;
        s.metaKeyEvents = void 0;
        for (let K of w.values()) (T = s.target) === null || T === void 0 || T.dispatchEvent(new KeyboardEvent("keyup", K));
      }
    };
    if (typeof PointerEvent < "u") {
      y.onPointerDown = (c) => {
        if (c.button !== 0 || !H(c.currentTarget, M(c.nativeEvent))) return;
        if (rr(c.nativeEvent)) {
          s.pointerType = "virtual";
          return;
        }
        s.pointerType = c.pointerType;
        let T = !0;
        if (!s.isPressed) {
          s.isPressed = !0, s.isOverTarget = !0, s.activePointerId = c.pointerId, s.target = c.currentTarget, p || Et(s.target), T = S(c, s.pointerType);
          let w = M(c.nativeEvent);
          "releasePointerCapture" in w && w.releasePointerCapture(c.pointerId), E(V(c.currentTarget), "pointerup", v, !1), E(V(c.currentTarget), "pointercancel", C, !1);
        }
        T && c.stopPropagation();
      }, y.onMouseDown = (c) => {
        if (H(c.currentTarget, M(c.nativeEvent)) && c.button === 0) {
          if (d) {
            let T = yt(c.target);
            T && s.disposables.push(T);
          }
          c.stopPropagation();
        }
      }, y.onPointerUp = (c) => {
        !H(c.currentTarget, M(c.nativeEvent)) || s.pointerType === "virtual" || c.button === 0 && I(c, s.pointerType || c.pointerType);
      }, y.onPointerEnter = (c) => {
        c.pointerId === s.activePointerId && s.target && !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, S(ce(s.target, c), s.pointerType));
      }, y.onPointerLeave = (c) => {
        c.pointerId === s.activePointerId && s.target && s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, F(ce(s.target, c), s.pointerType, !1), z(c));
      };
      let v = (c) => {
        if (c.pointerId === s.activePointerId && s.isPressed && c.button === 0 && s.target) {
          if (H(s.target, M(c)) && s.pointerType != null) {
            let T = !1, w = setTimeout(() => {
              s.isPressed && s.target instanceof HTMLElement && (T ? x(c) : (ve(s.target), s.target.click()));
            }, 80);
            E(c.currentTarget, "click", () => T = !0, !0), s.disposables.push(() => clearTimeout(w));
          } else x(c);
          s.isOverTarget = !1;
        }
      }, C = (c) => {
        x(c);
      };
      y.onDragStart = (c) => {
        H(c.currentTarget, M(c.nativeEvent)) && x(c);
      };
    } else if (process.env.NODE_ENV === "test") {
      y.onMouseDown = (c) => {
        if (c.button !== 0 || !H(c.currentTarget, M(c.nativeEvent))) return;
        if (s.ignoreEmulatedMouseEvents) {
          c.stopPropagation();
          return;
        }
        if (s.isPressed = !0, s.isOverTarget = !0, s.target = c.currentTarget, s.pointerType = Ze(c.nativeEvent) ? "virtual" : "mouse", _t(() => S(c, s.pointerType)) && c.stopPropagation(), d) {
          let w = yt(c.target);
          w && s.disposables.push(w);
        }
        E(V(c.currentTarget), "mouseup", v, !1);
      }, y.onMouseEnter = (c) => {
        if (!H(c.currentTarget, M(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !0, T = S(c, s.pointerType)), T && c.stopPropagation();
      }, y.onMouseLeave = (c) => {
        if (!H(c.currentTarget, M(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !1, T = F(c, s.pointerType, !1), z(c)), T && c.stopPropagation();
      }, y.onMouseUp = (c) => {
        H(c.currentTarget, M(c.nativeEvent)) && !s.ignoreEmulatedMouseEvents && c.button === 0 && I(c, s.pointerType || "mouse");
      };
      let v = (c) => {
        if (c.button === 0) {
          if (s.ignoreEmulatedMouseEvents) {
            s.ignoreEmulatedMouseEvents = !1;
            return;
          }
          s.target && s.target.contains(c.target) && s.pointerType != null || x(c), s.isOverTarget = !1;
        }
      };
      y.onTouchStart = (c) => {
        if (!H(c.currentTarget, M(c.nativeEvent))) return;
        let T = Er(c.nativeEvent);
        if (!T) return;
        s.activePointerId = T.identifier, s.ignoreEmulatedMouseEvents = !0, s.isOverTarget = !0, s.isPressed = !0, s.target = c.currentTarget, s.pointerType = "touch", p || Et(s.target), S(ne(s.target, c), s.pointerType) && c.stopPropagation(), E(X(c.currentTarget), "scroll", C, !0);
      }, y.onTouchMove = (c) => {
        if (!H(c.currentTarget, M(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = St(c.nativeEvent, s.activePointerId), w = !0;
        T && Lt(T, c.currentTarget) ? !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, w = S(ne(s.target, c), s.pointerType)) : s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, w = F(ne(s.target, c), s.pointerType, !1), z(ne(s.target, c))), w && c.stopPropagation();
      }, y.onTouchEnd = (c) => {
        if (!H(c.currentTarget, M(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = St(c.nativeEvent, s.activePointerId), w = !0;
        T && Lt(T, c.currentTarget) && s.pointerType != null ? (I(ne(s.target, c), s.pointerType), w = F(ne(s.target, c), s.pointerType), B(c.nativeEvent, s.target)) : s.isOverTarget && s.pointerType != null && (w = F(ne(s.target, c), s.pointerType, !1)), w && c.stopPropagation(), s.isPressed = !1, s.activePointerId = null, s.isOverTarget = !1, s.ignoreEmulatedMouseEvents = !0, s.target && !p && Ue(s.target), P();
      }, y.onTouchCancel = (c) => {
        H(c.currentTarget, M(c.nativeEvent)) && (c.stopPropagation(), s.isPressed && x(ne(s.target, c)));
      };
      let C = (c) => {
        s.isPressed && H(M(c), s.target) && x({
          currentTarget: s.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      y.onDragStart = (c) => {
        H(c.currentTarget, M(c.nativeEvent)) && x(c);
      };
    }
    return y;
  }, [
    E,
    a,
    d,
    P,
    p,
    x,
    z,
    F,
    S,
    I,
    U,
    B
  ]);
  return _(() => {
    if (!g || process.env.NODE_ENV === "test") return;
    const s = V(g.current);
    if (!s || !s.head || s.getElementById(wt)) return;
    const y = s.createElement("style");
    y.id = wt, y.textContent = `
@layer {
  [${xt}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), s.head.prepend(y);
  }, [
    g
  ]), _(() => {
    let s = h.current;
    return () => {
      var y;
      p || Ue((y = s.target) !== null && y !== void 0 ? y : void 0);
      for (let O of s.disposables) O();
      s.disposables = [];
    };
  }, [
    p
  ]), {
    isPressed: u || m,
    pressProps: j(b, k, {
      [xt]: !0
    })
  };
}
function pt(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function We(e, t) {
  const { key: n, code: r } = e, o = t, i = o.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(o instanceof X(o).HTMLInputElement && !nn(o, n) || o instanceof X(o).HTMLTextAreaElement || o.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && pt(o)) && n !== "Enter");
}
function Er(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function St(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const o = n[r];
    if (o.identifier === t) return o;
  }
  return null;
}
function ne(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function ce(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Pr(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Tr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Lt(e, t) {
  let n = t.getBoundingClientRect(), r = Pr(e);
  return Tr(n, r);
}
function wr(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !pt(e);
}
function Ct(e, t) {
  return e instanceof HTMLInputElement ? !nn(e, t) : wr(e);
}
const xr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function nn(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : xr.has(e.type);
}
let $e = null, Je = /* @__PURE__ */ new Set(), ye = /* @__PURE__ */ new Map(), se = !1, Qe = !1;
const Sr = {
  Tab: !0,
  Escape: !0
};
function vt(e, t) {
  for (let n of Je) n(e, t);
}
function Lr(e) {
  return !(e.metaKey || !be() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Me(e) {
  se = !0, Lr(e) && ($e = "keyboard", vt("keyboard", e));
}
function Y(e) {
  $e = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (se = !0, vt("pointer", e));
}
function rn(e) {
  Ze(e) && (se = !0, $e = "virtual");
}
function on(e) {
  e.target === window || e.target === document || Fe || !e.isTrusted || (!se && !Qe && ($e = "virtual", vt("virtual", e)), se = !1, Qe = !1);
}
function ln() {
  Fe || (se = !1, Qe = !0);
}
function et(e) {
  if (typeof window > "u" || typeof document > "u" || ye.get(X(e))) return;
  const t = X(e), n = V(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    se = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Me, !0), n.addEventListener("keyup", Me, !0), n.addEventListener("click", rn, !0), t.addEventListener("focus", on, !0), t.addEventListener("blur", ln, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Y, !0), n.addEventListener("pointermove", Y, !0), n.addEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Y, !0), n.addEventListener("mousemove", Y, !0), n.addEventListener("mouseup", Y, !0)), t.addEventListener("beforeunload", () => {
    an(e);
  }, {
    once: !0
  }), ye.set(t, {
    focus: r
  });
}
const an = (e, t) => {
  const n = X(e), r = V(e);
  t && r.removeEventListener("DOMContentLoaded", t), ye.has(n) && (n.HTMLElement.prototype.focus = ye.get(n).focus, r.removeEventListener("keydown", Me, !0), r.removeEventListener("keyup", Me, !0), r.removeEventListener("click", rn, !0), n.removeEventListener("focus", on, !0), n.removeEventListener("blur", ln, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Y, !0), r.removeEventListener("pointermove", Y, !0), r.removeEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Y, !0), r.removeEventListener("mousemove", Y, !0), r.removeEventListener("mouseup", Y, !0)), ye.delete(n));
};
function Cr(e) {
  const t = V(e);
  let n;
  return t.readyState !== "loading" ? et(e) : (n = () => {
    et(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => an(e, n);
}
typeof document < "u" && Cr();
function bt() {
  return $e !== "pointer";
}
function sn() {
  return $e;
}
const Or = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Fr(e, t, n) {
  let r = V(n == null ? void 0 : n.target);
  const o = typeof window < "u" ? X(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? X(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, l = typeof window < "u" ? X(n == null ? void 0 : n.target).HTMLElement : HTMLElement, a = typeof window < "u" ? X(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof o && !Or.has(r.activeElement.type) || r.activeElement instanceof i || r.activeElement instanceof l && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof a && !Sr[n.key]);
}
function Mr(e, t, n) {
  et(), _(() => {
    let r = (o, i) => {
      Fr(!!(n != null && n.isTextInput), o, i) && e(bt());
    };
    return Je.add(r), () => {
      Je.delete(r);
    };
  }, t);
}
function Ir(e) {
  const t = V(e), n = Ee(t);
  if (sn() === "virtual") {
    let r = n;
    jt(() => {
      Ee(t) === r && e.isConnected && ve(e);
    });
  } else ve(e);
}
function cn(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const i = R((u) => {
    if (u.target === u.currentTarget)
      return r && r(u), o && o(!1), !0;
  }, [
    r,
    o
  ]), l = Qt(i), a = R((u) => {
    const d = V(u.target), f = d ? Ee(d) : Ee();
    u.target === u.currentTarget && f === M(u.nativeEvent) && (n && n(u), o && o(!0), l(u));
  }, [
    o,
    n,
    l
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? a : void 0,
      onBlur: !t && (r || o) ? i : void 0
    }
  };
}
function Ot(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Dr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Ot(e.onKeyDown),
      onKeyUp: Ot(e.onKeyUp)
    }
  };
}
let un = /* @__PURE__ */ L.createContext(null);
function Hr(e) {
  let t = G(un) || {};
  Yt(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const kr = /* @__PURE__ */ L.forwardRef(function(t, n) {
  let { children: r, ...o } = t, i = Gt(n), l = {
    ...o,
    ref: i
  };
  return /* @__PURE__ */ L.createElement(un.Provider, {
    value: l
  }, r);
});
function dn(e, t) {
  let { focusProps: n } = cn(e), { keyboardProps: r } = Dr(e), o = j(n, r), i = Hr(t), l = e.isDisabled ? {} : i, a = D(e.autoFocus);
  _(() => {
    a.current && t.current && Ir(t.current), a.current = !1;
  }, [
    t
  ]);
  let u = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (u = void 0), {
    focusableProps: j({
      ...o,
      tabIndex: u
    }, l)
  };
}
function Nr(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, i = D({
    isFocusWithin: !1
  }), { addGlobalListener: l, removeAllGlobalListeners: a } = dt(), u = R((p) => {
    p.currentTarget.contains(p.target) && i.current.isFocusWithin && !p.currentTarget.contains(p.relatedTarget) && (i.current.isFocusWithin = !1, a(), n && n(p), o && o(!1));
  }, [
    n,
    o,
    i,
    a
  ]), d = Qt(u), f = R((p) => {
    if (!p.currentTarget.contains(p.target)) return;
    const g = V(p.target), b = Ee(g);
    if (!i.current.isFocusWithin && b === M(p.nativeEvent)) {
      r && r(p), o && o(!0), i.current.isFocusWithin = !0, d(p);
      let m = p.currentTarget;
      l(g, "focus", ($) => {
        if (i.current.isFocusWithin && !H(m, $.target)) {
          let h = new g.defaultView.FocusEvent("blur", {
            relatedTarget: $.target
          });
          Jt(h, m);
          let E = ft(h);
          u(E);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    o,
    d,
    l,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: u
    }
  };
}
let Ie = !1, je = 0;
function tt() {
  Ie = !0, setTimeout(() => {
    Ie = !1;
  }, 50);
}
function Ft(e) {
  e.pointerType === "touch" && tt();
}
function Rr() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Ft) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", tt), je++, () => {
      je--, !(je > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Ft) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", tt));
    };
}
function _e(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [i, l] = W(!1), a = D({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  _(Rr, []);
  let { addGlobalListener: u, removeAllGlobalListeners: d } = dt(), { hoverProps: f, triggerHoverEnd: p } = ie(() => {
    let g = ($, h) => {
      if (a.pointerType = h, o || h === "touch" || a.isHovered || !$.currentTarget.contains($.target)) return;
      a.isHovered = !0;
      let E = $.currentTarget;
      a.target = E, u(V($.target), "pointerover", (P) => {
        a.isHovered && a.target && !H(a.target, P.target) && b(P, P.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: E,
        pointerType: h
      }), n && n(!0), l(!0);
    }, b = ($, h) => {
      let E = a.target;
      a.pointerType = "", a.target = null, !(h === "touch" || !a.isHovered || !E) && (a.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: E,
        pointerType: h
      }), n && n(!1), l(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = ($) => {
      Ie && $.pointerType === "mouse" || g($, $.pointerType);
    }, m.onPointerLeave = ($) => {
      !o && $.currentTarget.contains($.target) && b($, $.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      a.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = ($) => {
      !a.ignoreEmulatedMouseEvents && !Ie && g($, "mouse"), a.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = ($) => {
      !o && $.currentTarget.contains($.target) && b($, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: b
    };
  }, [
    t,
    n,
    r,
    o,
    a,
    u,
    d
  ]);
  return _(() => {
    o && p({
      currentTarget: a.target
    }, a.pointerType);
  }, [
    o
  ]), {
    hoverProps: f,
    isHovered: i
  };
}
const Ar = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Kr = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function _r(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Ar.has(n.script);
  }
  let t = e.split("-")[0];
  return Kr.has(t);
}
const Vr = Symbol.for("react-aria.i18n.locale");
function fn() {
  let e = typeof window < "u" && window[Vr] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: _r(e) ? "rtl" : "ltr"
  };
}
let nt = fn(), he = /* @__PURE__ */ new Set();
function Mt() {
  nt = fn();
  for (let e of he) e(nt);
}
function zr() {
  let e = lt(), [t, n] = W(nt);
  return _(() => (he.size === 0 && window.addEventListener("languagechange", Mt), he.add(n), () => {
    he.delete(n), he.size === 0 && window.removeEventListener("languagechange", Mt);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Br = /* @__PURE__ */ L.createContext(null);
function pn() {
  let e = zr();
  return G(Br) || e;
}
let Ge = /* @__PURE__ */ new Map(), rt = !1;
try {
  rt = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let De = !1;
try {
  De = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const vn = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Ur {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!rt && this.options.signDisplay != null ? n = jr(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !De) {
      var r;
      let { unit: o, unitDisplay: i = "short", locale: l } = this.resolvedOptions();
      if (!o) return n;
      let a = (r = vn[o]) === null || r === void 0 ? void 0 : r[i];
      n += a[l] || a.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), o = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !rt && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !De && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = Wr(t, n), this.options = n;
  }
}
function Wr(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !De) {
    var r;
    let { unit: l, unitDisplay: a = "short" } = t;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = vn[l]) === null || r === void 0) && r[a])) throw new Error(`Unsupported unit ${l} with unitDisplay = ${a}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let o = e + (t ? Object.entries(t).sort((l, a) => l[0] < a[0] ? -1 : 1).join() : "");
  if (Ge.has(o)) return Ge.get(o);
  let i = new Intl.NumberFormat(e, t);
  return Ge.set(o, i), i;
}
function jr(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let o = e.format(-n), i = e.format(n), l = o.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...l
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(i, "!!!").replace(l, "+").replace("!!!", i);
    } else return e.format(n);
  }
}
function Gr(e = {}) {
  let { locale: t } = pn();
  return ie(() => new Ur(t, e), [
    t,
    e
  ]);
}
function bn(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: o, onPressStart: i, onPressEnd: l, onPressUp: a, onPressChange: u, preventFocusOnPress: d, allowFocusWhenDisabled: f, onClick: p, href: g, target: b, rel: m, type: $ = "button" } = e, h;
  n === "button" ? h = {
    type: $,
    disabled: r
  } : h = {
    role: "button",
    href: n === "a" && !r ? g : void 0,
    target: n === "a" ? b : void 0,
    type: n === "input" ? $ : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? m : void 0
  };
  let { pressProps: E, isPressed: P } = yr({
    onPressStart: i,
    onPressEnd: l,
    onPressChange: u,
    onPress: o,
    onPressUp: a,
    onClick: p,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: t
  }), { focusableProps: S } = dn(e, t);
  f && (S.tabIndex = r ? -1 : S.tabIndex);
  let F = j(S, E, Ne(e, {
    labelable: !0
  }));
  return {
    isPressed: P,
    buttonProps: j(h, F, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"]
    })
  };
}
function $n(e, t, n) {
  const { isSelected: r } = t, { isPressed: o, buttonProps: i } = bn({
    ...e,
    onPress: at(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: o,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: j(i, {
      "aria-pressed": r
    })
  };
}
function gn(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = D({
    isFocused: !1,
    isFocusVisible: t || bt()
  }), [i, l] = W(!1), [a, u] = W(() => o.current.isFocused && o.current.isFocusVisible), d = R(() => u(o.current.isFocused && o.current.isFocusVisible), []), f = R((b) => {
    o.current.isFocused = b, l(b), d();
  }, [
    d
  ]);
  Mr((b) => {
    o.current.isFocusVisible = b, d();
  }, [], {
    isTextInput: n
  });
  let { focusProps: p } = cn({
    isDisabled: r,
    onFocusChange: f
  }), { focusWithinProps: g } = Nr({
    isDisabled: !r,
    onFocusWithinChange: f
  });
  return {
    isFocused: i,
    isFocusVisible: a,
    focusProps: r ? g : p
  };
}
function Yr(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    setSelected(u) {
      t.setSelected(e.id, u);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: o, isSelected: i, isDisabled: l, buttonProps: a } = $n({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (a.role = "radio", a["aria-checked"] = r.isSelected, delete a["aria-pressed"]), {
    isPressed: o,
    isSelected: i,
    isDisabled: l,
    buttonProps: a
  };
}
const mn = 7e3;
let q = null;
function It(e, t = "assertive", n = mn) {
  q ? q.announce(e, t, n) : (q = new Xr(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? q.announce(e, t, n) : setTimeout(() => {
    q != null && q.isAttached() && (q == null || q.announce(e, t, n));
  }, 100));
}
class Xr {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = mn) {
    var o, i;
    if (!this.node) return;
    let l = document.createElement("div");
    typeof t == "object" ? (l.setAttribute("role", "img"), l.setAttribute("aria-labelledby", t["aria-labelledby"])) : l.textContent = t, n === "assertive" ? (o = this.assertiveLog) === null || o === void 0 || o.appendChild(l) : (i = this.politeLog) === null || i === void 0 || i.appendChild(l), t !== "" && setTimeout(() => {
      l.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function Zr(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": o, labelElementType: i = "label" } = e;
  t = pe(t);
  let l = pe(), a = {};
  n ? (r = r ? `${l} ${r}` : l, a = {
    id: l,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !o && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = tr({
    id: t,
    "aria-label": o,
    "aria-labelledby": r
  });
  return {
    labelProps: a,
    fieldProps: u
  };
}
function qr(e = {}) {
  let { isReadOnly: t } = e, [n, r] = qt(e.isSelected, e.defaultSelected || !1, e.onChange);
  function o(l) {
    t || r(l);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: o,
    toggle: i
  };
}
const J = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, He = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Jr = {
  top: "left",
  left: "top"
}, ot = {
  top: "height",
  left: "width"
}, hn = {
  width: "totalWidth",
  height: "totalHeight"
}, Le = {};
let A = typeof document < "u" ? window.visualViewport : null;
function Dt(e) {
  let t = 0, n = 0, r = 0, o = 0, i = 0, l = 0, a = {};
  var u;
  let d = ((u = A == null ? void 0 : A.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY") {
    let m = document.documentElement;
    r = m.clientWidth, o = m.clientHeight;
    var f;
    t = (f = A == null ? void 0 : A.width) !== null && f !== void 0 ? f : r;
    var p;
    n = (p = A == null ? void 0 : A.height) !== null && p !== void 0 ? p : o, a.top = m.scrollTop || e.scrollTop, a.left = m.scrollLeft || e.scrollLeft, A && (i = A.offsetTop, l = A.offsetLeft);
  } else
    ({ width: t, height: n, top: i, left: l } = fe(e)), a.top = e.scrollTop, a.left = e.scrollLeft, r = t, o = n;
  if (Ut() && (e.tagName === "BODY" || e.tagName === "HTML") && d) {
    a.top = 0, a.left = 0;
    var g;
    i = (g = A == null ? void 0 : A.pageTop) !== null && g !== void 0 ? g : 0;
    var b;
    l = (b = A == null ? void 0 : A.pageLeft) !== null && b !== void 0 ? b : 0;
  }
  return {
    width: t,
    height: n,
    totalWidth: r,
    totalHeight: o,
    scroll: a,
    top: i,
    left: l
  };
}
function Qr(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function Ht(e, t, n, r, o, i, l) {
  var a;
  let u = (a = o.scroll[e]) !== null && a !== void 0 ? a : 0, d = r[ot[e]], f = r.scroll[J[e]] + i, p = d + r.scroll[J[e]] - i, g = t - u + l[e] - r[J[e]], b = t - u + n + l[e] - r[J[e]];
  return g < f ? f - g : b > p ? Math.max(p - b, f - g) : 0;
}
function eo(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function kt(e) {
  if (Le[e]) return Le[e];
  let [t, n] = e.split(" "), r = J[t] || "right", o = Jr[r];
  J[n] || (n = "center");
  let i = ot[r], l = ot[o];
  return Le[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: o,
    size: i,
    crossSize: l
  }, Le[e];
}
function Ye(e, t, n, r, o, i, l, a, u, d) {
  let { placement: f, crossPlacement: p, axis: g, crossAxis: b, size: m, crossSize: $ } = r, h = {};
  var E;
  h[b] = (E = e[b]) !== null && E !== void 0 ? E : 0;
  var P, S, F, I;
  p === "center" ? h[b] += (((P = e[$]) !== null && P !== void 0 ? P : 0) - ((S = n[$]) !== null && S !== void 0 ? S : 0)) / 2 : p !== b && (h[b] += ((F = e[$]) !== null && F !== void 0 ? F : 0) - ((I = n[$]) !== null && I !== void 0 ? I : 0)), h[b] += i;
  const x = e[b] - n[$] + u + d, z = e[b] + e[$] - u - d;
  if (h[b] = Te(h[b], x, z), f === g) {
    const U = a ? l[m] : t[hn[m]];
    h[He[g]] = Math.floor(U - e[g] + o);
  } else h[g] = Math.floor(e[g] + e[m] + o);
  return h;
}
function to(e, t, n, r, o, i, l, a) {
  const u = r ? n.height : t[hn.height];
  var d;
  let f = e.top != null ? n.top + e.top : n.top + (u - ((d = e.bottom) !== null && d !== void 0 ? d : 0) - l);
  var p, g, b, m, $, h;
  let E = a !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, t.height + t.top + ((p = t.scroll.top) !== null && p !== void 0 ? p : 0) - f - (((g = o.top) !== null && g !== void 0 ? g : 0) + ((b = o.bottom) !== null && b !== void 0 ? b : 0) + i))
  ) : Math.max(0, f + l - (t.top + ((m = t.scroll.top) !== null && m !== void 0 ? m : 0)) - ((($ = o.top) !== null && $ !== void 0 ? $ : 0) + ((h = o.bottom) !== null && h !== void 0 ? h : 0) + i));
  return Math.min(t.height - i * 2, E);
}
function Nt(e, t, n, r, o, i) {
  let { placement: l, axis: a, size: u } = i;
  var d, f;
  if (l === a) return Math.max(0, n[a] - e[a] - ((d = e.scroll[a]) !== null && d !== void 0 ? d : 0) + t[a] - ((f = r[a]) !== null && f !== void 0 ? f : 0) - r[He[a]] - o);
  var p;
  return Math.max(0, e[u] + e[a] + e.scroll[a] - t[a] - n[a] - n[u] - ((p = r[a]) !== null && p !== void 0 ? p : 0) - r[He[a]] - o);
}
function no(e, t, n, r, o, i, l, a, u, d, f, p, g, b, m, $) {
  let h = kt(e), { size: E, crossAxis: P, crossSize: S, placement: F, crossPlacement: I } = h, x = Ye(t, a, n, h, f, p, d, g, m, $), z = f, U = Nt(a, d, t, o, i + f, h);
  if (l && r[E] > U) {
    let ze = kt(`${He[F]} ${I}`), Sn = Ye(t, a, n, ze, f, p, d, g, m, $);
    Nt(a, d, t, o, i + f, ze) > U && (h = ze, x = Sn, z = f);
  }
  let B = "bottom";
  h.axis === "top" ? h.placement === "top" ? B = "top" : h.placement === "bottom" && (B = "bottom") : h.crossAxis === "top" && (h.crossPlacement === "top" ? B = "bottom" : h.crossPlacement === "bottom" && (B = "top"));
  let k = Ht(P, x[P], n[S], a, u, i, d);
  x[P] += k;
  let s = to(x, a, d, g, o, i, n.height, B);
  b && b < s && (s = b), n.height = Math.min(n.height, s), x = Ye(t, a, n, h, z, p, d, g, m, $), k = Ht(P, x[P], n[S], a, u, i, d), x[P] += k;
  let y = {}, O = t[P] + 0.5 * t[S] - x[P] - o[J[P]];
  const v = m / 2 + $;
  var C, c, T, w;
  const K = J[P] === "left" ? ((C = o.left) !== null && C !== void 0 ? C : 0) + ((c = o.right) !== null && c !== void 0 ? c : 0) : ((T = o.top) !== null && T !== void 0 ? T : 0) + ((w = o.bottom) !== null && w !== void 0 ? w : 0), Ve = n[S] - K - m / 2 - $, Tn = t[P] + m / 2 - (x[P] + o[J[P]]), wn = t[P] + t[S] - m / 2 - (x[P] + o[J[P]]), xn = Te(O, Tn, wn);
  return y[P] = Te(xn, v, Ve), {
    position: x,
    maxHeight: s,
    arrowOffsetLeft: y.left,
    arrowOffsetTop: y.top,
    placement: h.placement
  };
}
function ro(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: o, padding: i, shouldFlip: l, boundaryElement: a, offset: u, crossOffset: d, maxHeight: f, arrowSize: p = 0, arrowBoundaryOffset: g = 0 } = e, b = r instanceof HTMLElement ? oo(r) : document.documentElement, m = b === document.documentElement;
  const $ = window.getComputedStyle(b).position;
  let h = !!$ && $ !== "static", E = m ? fe(n) : Rt(n, b);
  if (!m) {
    let { marginTop: y, marginLeft: O } = window.getComputedStyle(n);
    E.top += parseInt(y, 10) || 0, E.left += parseInt(O, 10) || 0;
  }
  let P = fe(r), S = eo(r);
  var F, I;
  P.width += ((F = S.left) !== null && F !== void 0 ? F : 0) + ((I = S.right) !== null && I !== void 0 ? I : 0);
  var x, z;
  P.height += ((x = S.top) !== null && x !== void 0 ? x : 0) + ((z = S.bottom) !== null && z !== void 0 ? z : 0);
  let U = Qr(o), B = Dt(a), k = Dt(b), s = a.tagName === "BODY" ? fe(b) : Rt(b, a);
  return b.tagName === "HTML" && a.tagName === "BODY" && (k.scroll.top = 0, k.scroll.left = 0), no(t, E, P, U, S, i, l, B, k, s, u, d, h, f, p, g);
}
function fe(e) {
  let { top: t, left: n, width: r, height: o } = e.getBoundingClientRect(), { scrollTop: i, scrollLeft: l, clientTop: a, clientLeft: u } = document.documentElement;
  return {
    top: t + i - a,
    left: n + l - u,
    width: r,
    height: o
  };
}
function Rt(e, t) {
  let n = window.getComputedStyle(e), r;
  if (n.position === "fixed") {
    let { top: o, left: i, width: l, height: a } = e.getBoundingClientRect();
    r = {
      top: o,
      left: i,
      width: l,
      height: a
    };
  } else {
    r = fe(e);
    let o = fe(t), i = window.getComputedStyle(t);
    o.top += (parseInt(i.borderTopWidth, 10) || 0) - t.scrollTop, o.left += (parseInt(i.borderLeftWidth, 10) || 0) - t.scrollLeft, r.top -= o.top, r.left -= o.left;
  }
  return r.top -= parseInt(n.marginTop, 10) || 0, r.left -= parseInt(n.marginLeft, 10) || 0, r;
}
function oo(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !At(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !At(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function At(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const io = /* @__PURE__ */ new WeakMap();
function lo(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  _(() => {
    if (!n || r === null) return;
    let o = (i) => {
      let l = i.target;
      if (!t.current || l instanceof Node && !l.contains(t.current) || i.target instanceof HTMLInputElement || i.target instanceof HTMLTextAreaElement) return;
      let a = r || io.get(t.current);
      a && a();
    };
    return window.addEventListener("scroll", o, !0), () => {
      window.removeEventListener("scroll", o, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
let N = typeof document < "u" ? window.visualViewport : null;
function ao(e) {
  let { direction: t } = pn(), { arrowSize: n = 0, targetRef: r, overlayRef: o, scrollRef: i = o, placement: l = "bottom", containerPadding: a = 12, shouldFlip: u = !0, boundaryElement: d = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: p = 0, shouldUpdatePosition: g = !0, isOpen: b = !0, onClose: m, maxHeight: $, arrowBoundaryOffset: h = 0 } = e, [E, P] = W(null), S = [
    g,
    l,
    o.current,
    r.current,
    i.current,
    a,
    u,
    d,
    f,
    p,
    b,
    t,
    $,
    h,
    n
  ], F = D(N == null ? void 0 : N.scale);
  _(() => {
    b && (F.current = N == null ? void 0 : N.scale);
  }, [
    b
  ]);
  let I = R(() => {
    if (g === !1 || !b || !o.current || !r.current || !d || (N == null ? void 0 : N.scale) !== F.current) return;
    let k = null;
    if (i.current && i.current.contains(document.activeElement)) {
      var s;
      let w = (s = document.activeElement) === null || s === void 0 ? void 0 : s.getBoundingClientRect(), K = i.current.getBoundingClientRect();
      var y;
      if (k = {
        type: "top",
        offset: ((y = w == null ? void 0 : w.top) !== null && y !== void 0 ? y : 0) - K.top
      }, k.offset > K.height / 2) {
        k.type = "bottom";
        var O;
        k.offset = ((O = w == null ? void 0 : w.bottom) !== null && O !== void 0 ? O : 0) - K.bottom;
      }
    }
    let v = o.current;
    if (!$ && o.current) {
      var C;
      v.style.top = "0px", v.style.bottom = "";
      var c;
      v.style.maxHeight = ((c = (C = window.visualViewport) === null || C === void 0 ? void 0 : C.height) !== null && c !== void 0 ? c : window.innerHeight) + "px";
    }
    let T = ro({
      placement: co(l, t),
      overlayNode: o.current,
      targetNode: r.current,
      scrollNode: i.current || o.current,
      padding: a,
      shouldFlip: u,
      boundaryElement: d,
      offset: f,
      crossOffset: p,
      maxHeight: $,
      arrowSize: n,
      arrowBoundaryOffset: h
    });
    if (T.position) {
      if (v.style.top = "", v.style.bottom = "", v.style.left = "", v.style.right = "", Object.keys(T.position).forEach((w) => v.style[w] = T.position[w] + "px"), v.style.maxHeight = T.maxHeight != null ? T.maxHeight + "px" : "", k && document.activeElement && i.current) {
        let w = document.activeElement.getBoundingClientRect(), K = i.current.getBoundingClientRect(), Ve = w[k.type] - K[k.type];
        i.current.scrollTop += Ve - k.offset;
      }
      P(T);
    }
  }, S);
  Z(I, S), so(I), ht({
    ref: o,
    onResize: I
  }), ht({
    ref: r,
    onResize: I
  });
  let x = D(!1);
  Z(() => {
    let k, s = () => {
      x.current = !0, clearTimeout(k), k = setTimeout(() => {
        x.current = !1;
      }, 500), I();
    }, y = () => {
      x.current && s();
    };
    return N == null || N.addEventListener("resize", s), N == null || N.addEventListener("scroll", y), () => {
      N == null || N.removeEventListener("resize", s), N == null || N.removeEventListener("scroll", y);
    };
  }, [
    I
  ]);
  let z = R(() => {
    x.current || m == null || m();
  }, [
    m,
    x
  ]);
  lo({
    triggerRef: r,
    isOpen: b,
    onClose: m && z
  });
  var U, B;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...E == null ? void 0 : E.position,
        maxHeight: (U = E == null ? void 0 : E.maxHeight) !== null && U !== void 0 ? U : "100vh"
      }
    },
    placement: (B = E == null ? void 0 : E.placement) !== null && B !== void 0 ? B : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: E == null ? void 0 : E.arrowOffsetLeft,
        top: E == null ? void 0 : E.arrowOffsetTop
      }
    },
    updatePosition: I
  };
}
function so(e) {
  Z(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function co(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
const uo = /* @__PURE__ */ Q({});
function fo() {
  var e;
  return (e = G(uo)) !== null && e !== void 0 ? e : {};
}
const it = /* @__PURE__ */ L.createContext(null);
function po(e) {
  let { children: t } = e, n = G(it), [r, o] = W(0), i = ie(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      o((l) => l + 1), n && n.addModal();
    },
    removeModal() {
      o((l) => l - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ L.createElement(it.Provider, {
    value: i
  }, t);
}
function vo() {
  let e = G(it);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function bo(e) {
  let { modalProviderProps: t } = vo();
  return /* @__PURE__ */ L.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function $o(e) {
  return /* @__PURE__ */ L.createElement(po, null, /* @__PURE__ */ L.createElement(bo, e));
}
function go(e) {
  let t = lt(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: o } = fo();
  if (!e.portalContainer && o && (n = o()), L.useEffect(() => {
    if (n != null && n.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let i = /* @__PURE__ */ L.createElement($o, r);
  return /* @__PURE__ */ Ln.createPortal(i, n);
}
function mo(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: o, isIndeterminate: i, formatOptions: l = {
    style: "percent"
  } } = e, a = Ne(e, {
    labelable: !0
  }), { labelProps: u, fieldProps: d } = Zr({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Te(t, n, r);
  let f = (t - n) / (r - n), p = Gr(l);
  if (!i && !o) {
    let g = l.style === "percent" ? f : t;
    o = p.format(g);
  }
  return {
    progressBarProps: j(a, {
      ...d,
      "aria-valuenow": i ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": i ? void 0 : o,
      role: "progressbar"
    }),
    labelProps: u
  };
}
function ho(e, t) {
  let n = Ne(e, {
    labelable: !0
  }), { hoverProps: r } = _e({
    onHoverStart: () => t == null ? void 0 : t.open(!0),
    onHoverEnd: () => t == null ? void 0 : t.close()
  });
  return {
    tooltipProps: j(n, r, {
      role: "tooltip"
    })
  };
}
function yo(e, t, n) {
  let { isDisabled: r, trigger: o } = e, i = pe(), l = D(!1), a = D(!1), u = () => {
    (l.current || a.current) && t.open(a.current);
  }, d = (E) => {
    !l.current && !a.current && t.close(E);
  };
  _(() => {
    let E = (P) => {
      n && n.current && P.key === "Escape" && (P.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", E, !0), () => {
        document.removeEventListener("keydown", E, !0);
      };
  }, [
    n,
    t
  ]);
  let f = () => {
    o !== "focus" && (sn() === "pointer" ? l.current = !0 : l.current = !1, u());
  }, p = () => {
    o !== "focus" && (a.current = !1, l.current = !1, d());
  }, g = () => {
    a.current = !1, l.current = !1, d(!0);
  }, b = () => {
    bt() && (a.current = !0, u());
  }, m = () => {
    a.current = !1, l.current = !1, d(!0);
  }, { hoverProps: $ } = _e({
    isDisabled: r,
    onHoverStart: f,
    onHoverEnd: p
  }), { focusableProps: h } = dn({
    isDisabled: r,
    onFocus: b,
    onBlur: m
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? i : void 0,
      ...j(h, $, {
        onPointerDown: g,
        onKeyDown: g,
        tabIndex: void 0
      })
    },
    tooltipProps: {
      id: i
    }
  };
}
const Eo = /* @__PURE__ */ Q({}), yn = /* @__PURE__ */ Q(null), ko = /* @__PURE__ */ ke(function(t, n) {
  [t, n] = Ke(t, n, yn);
  let { value: r = 0, minValue: o = 0, maxValue: i = 100, isIndeterminate: l = !1 } = t;
  r = Te(r, o, i);
  let [a, u] = dr(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: d, labelProps: f } = mo({
    ...t,
    label: u
  }), p = l ? void 0 : (r - o) / (i - o) * 100, g = Ae({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: p,
      valueText: d["aria-valuetext"],
      isIndeterminate: l
    }
  });
  return /* @__PURE__ */ L.createElement("div", {
    ...d,
    ...g,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ L.createElement(Eo.Provider, {
    value: {
      ...f,
      ref: a,
      elementType: "span"
    }
  }, g.children));
}), Po = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), To = /* @__PURE__ */ Q({}), No = /* @__PURE__ */ pr(function(t, n) {
  [t, n] = Ke(t, n, To), t = wo(t);
  let r = t, { isPending: o } = r, { buttonProps: i, isPressed: l } = bn(t, n), { focusProps: a, isFocused: u, isFocusVisible: d } = gn(t), { hoverProps: f, isHovered: p } = _e({
    ...t,
    isDisabled: t.isDisabled || o
  }), g = {
    isHovered: p,
    isPressed: (r.isPressed || l) && !o,
    isFocused: u,
    isFocusVisible: d,
    isDisabled: t.isDisabled || !1,
    isPending: o ?? !1
  }, b = Ae({
    ...t,
    values: g,
    defaultClassName: "react-aria-Button"
  }), m = pe(i.id), $ = pe(), h = i["aria-labelledby"];
  o && (h ? h = `${h} ${$}` : i["aria-label"] && (h = `${m} ${$}`));
  let E = D(o);
  return _(() => {
    let P = {
      "aria-labelledby": h || m
    };
    (!E.current && u && o || E.current && u && !o) && It(P, "assertive"), E.current = o;
  }, [
    o,
    u,
    h,
    m
  ]), /* @__PURE__ */ L.createElement("button", {
    ...Ne(t, {
      propNames: Po
    }),
    ...j(i, a, f),
    ...b,
    type: i.type === "submit" && o ? "button" : i.type,
    id: m,
    ref: n,
    "aria-labelledby": h,
    slot: t.slot || void 0,
    "aria-disabled": o ? "true" : i["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": g.isPressed || void 0,
    "data-hovered": p || void 0,
    "data-focused": u || void 0,
    "data-pending": o || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ L.createElement(yn.Provider, {
    value: {
      id: $
    }
  }, b.children));
});
function wo(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
function xo(e) {
  let [t, n] = qt(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = R(() => {
    n(!0);
  }, [
    n
  ]), o = R(() => {
    n(!1);
  }, [
    n
  ]), i = R(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: o,
    toggle: i
  };
}
const So = 1500, Kt = 500;
let le = {}, Lo = 0, ge = !1, ee = null, ae = null;
function En(e = {}) {
  let { delay: t = So, closeDelay: n = Kt } = e, { isOpen: r, open: o, close: i } = xo(e), l = ie(() => `${++Lo}`, []), a = D(null), u = D(i), d = () => {
    le[l] = g;
  }, f = () => {
    for (let m in le) m !== l && (le[m](!0), delete le[m]);
  }, p = () => {
    a.current && clearTimeout(a.current), a.current = null, f(), d(), ge = !0, o(), ee && (clearTimeout(ee), ee = null), ae && (clearTimeout(ae), ae = null);
  }, g = (m) => {
    m || n <= 0 ? (a.current && clearTimeout(a.current), a.current = null, u.current()) : a.current || (a.current = setTimeout(() => {
      a.current = null, u.current();
    }, n)), ee && (clearTimeout(ee), ee = null), ge && (ae && clearTimeout(ae), ae = setTimeout(() => {
      delete le[l], ae = null, ge = !1;
    }, Math.max(Kt, n)));
  }, b = () => {
    f(), d(), !r && !ee && !ge ? ee = setTimeout(() => {
      ee = null, ge = !0, p();
    }, t) : r || p();
  };
  return _(() => {
    u.current = i;
  }, [
    i
  ]), _(() => () => {
    a.current && clearTimeout(a.current), le[l] && delete le[l];
  }, [
    l
  ]), {
    isOpen: r,
    open: (m) => {
      !m && t > 0 && !a.current ? b() : p();
    },
    close: g
  };
}
const Co = /* @__PURE__ */ Q({
  placement: "bottom"
}), Oo = /* @__PURE__ */ Q(null), Fo = /* @__PURE__ */ Q({}), Ro = /* @__PURE__ */ ke(function(t, n) {
  [t, n] = Ke(t, n, Fo);
  let r = G(Oo), o = qr(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange($) {
      r.setSelected(t.id, $);
    }
  } : t), { buttonProps: i, isPressed: l, isSelected: a, isDisabled: u } = r && t.id != null ? Yr({
    ...t,
    id: t.id
  }, r, n) : $n({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, o, n), { focusProps: d, isFocused: f, isFocusVisible: p } = gn(t), { hoverProps: g, isHovered: b } = _e(t), m = Ae({
    ...t,
    id: void 0,
    values: {
      isHovered: b,
      isPressed: l,
      isFocused: f,
      isSelected: o.isSelected,
      isFocusVisible: p,
      isDisabled: u,
      state: o
    },
    defaultClassName: "react-aria-ToggleButton"
  });
  return /* @__PURE__ */ L.createElement("button", {
    ...j(i, d, g),
    ...m,
    ref: n,
    slot: t.slot || void 0,
    "data-focused": f || void 0,
    "data-disabled": u || void 0,
    "data-pressed": l || void 0,
    "data-selected": a || void 0,
    "data-hovered": b || void 0,
    "data-focus-visible": p || void 0
  });
}), $t = /* @__PURE__ */ Q(null), Pn = /* @__PURE__ */ Q(null);
function Ao(e) {
  let t = En(e), n = D(null), { triggerProps: r, tooltipProps: o } = yo(e, t, n);
  return /* @__PURE__ */ L.createElement(cr, {
    values: [
      [
        $t,
        t
      ],
      [
        Pn,
        {
          ...o,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ L.createElement(kr, {
    ...r,
    ref: n
  }, e.children));
}
const Ko = /* @__PURE__ */ ke(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = Ke(n, r, Pn);
  let o = G($t), i = En(n), l = n.isOpen != null || n.defaultOpen != null || !o ? i : o, a = ir(r, l.isOpen) || n.isExiting || !1;
  return !l.isOpen && !a ? null : /* @__PURE__ */ L.createElement(go, {
    portalContainer: t
  }, /* @__PURE__ */ L.createElement(Mo, {
    ...n,
    tooltipRef: r,
    isExiting: a
  }));
});
function Mo(e) {
  let t = G($t), n = D(null), [r, o] = W(0);
  Z(() => {
    n.current && t.isOpen && o(n.current.getBoundingClientRect().width);
  }, [
    t.isOpen,
    n
  ]);
  let { overlayProps: i, arrowProps: l, placement: a } = ao({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowSize: r,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    onClose: () => t.close(!0)
  }), u = or(e.tooltipRef, !!a) || e.isEntering || !1, d = Ae({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: a,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = j(e, i);
  let { tooltipProps: f } = ho(e, t);
  return /* @__PURE__ */ L.createElement("div", {
    ...f,
    ref: e.tooltipRef,
    ...d,
    style: {
      ...i.style,
      ...d.style
    },
    "data-placement": a ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ L.createElement(Co.Provider, {
    value: {
      ...l,
      placement: a,
      ref: n
    }
  }, d.children));
}
export {
  Ro as $,
  No as a,
  ko as b,
  Cn as c,
  Ao as d,
  Ko as e
};
//# sourceMappingURL=vendor-B6xhktLJ.js.map
